import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { List, ListItem, ListItemText, useTheme } from '@mui/material';
import React from 'react';

export interface RuleFieldsListProps {
  fields: Array<{ label: string; value: React.ReactNode }>;
  variant: 'emphasis' | 'body';
}

export const RuleFieldsList = ({ fields, variant }: RuleFieldsListProps) => {
  const { tokens } = useTheme<LensTheme>();

  return (
    <List
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        m: 0,
        p: 0,
        listStyle: 'none',
        width: '100%',
      }}
    >
      {fields.map(({ label, value }, index) => (
        <ListItem
          key={label}
          sx={{
            boxShadow:
              index !== 4 && index !== 9
                ? `1px solid ${tokens.semantic.color.action.secondary.disabledOutline.value}`
                : 'none',
            padding: `${tokens.core.spacing['1_5'].value} 0`,
            minHeight: index !== 4 && index !== 9 ? '48px' : 'auto',
            alignItems: index !== 4 && index !== 9 ? 'center' : 'flex-start',
          }}
        >
          <ListItemText
            primary={variant === 'emphasis' ? label : value}
            sx={{
              '& .MuiListItemText-primary': {
                fontFamily: tokens.semantic.font.text.body.fontFamily.value,
                fontSize: `${tokens.semantic.font.text.body.fontSize.value}px`,
                fontWeight:
                  variant === 'emphasis'
                    ? tokens.semantic.fontWeight.emphasis.value
                    : tokens.semantic.font.text.body.fontWeight.value,
                letterSpacing: `${tokens.semantic.font.text.body.letterSpacing.value}px`,
                lineHeight: `${tokens.semantic.font.text.body.lineHeight.value}px`,
              },
            }}
          />
        </ListItem>
      ))}
    </List>
  );
};
